import { Button, Drawer, Spin } from "antd";
import useFooterStore from "views/hooks/useFooterStore";
import DocumentViewer from "components/DocumentViewer";
import invoiceStore from "views/hooks/useInvoiceStore";
import { useTranslation } from "react-i18next";
import { FaEye, FaSave } from "react-icons/fa";

export default function SaveButtons(): React.ReactElement {
  const { t } = useTranslation();
  const setHandleSaveAndPreview = useFooterStore(state => state.setHandleSaveAndPreview);
  const setHandleOkSaveButton = useFooterStore(state => state.setHandleOkSaveButton);
  const saveLoading = useFooterStore(state => state.saveLoading);
  const openPreviewModal = useFooterStore(state => state.openPreviewModal);
  const setOpenPreviewModal = useFooterStore(state => state.setOpenPreviewModal);
  const previewUrl = invoiceStore(state => state.previewUrl);

  const handleCancel = () => {
    setOpenPreviewModal(false);
  };

  const handleSaveAndPreview = () => {
    setHandleSaveAndPreview(true);
  };

  return (
    <>
      <div className="floating-footer">
        <Button
          onClick={handleSaveAndPreview}
          icon={<FaEye />}
          className="floating-footer__button floating-footer__button--back"
        >
          {t("Save & Preview")}
        </Button>
        <div className="floating-footer__divider" />
        <Button
          type="primary"
          loading={saveLoading}
          onClick={() => setHandleOkSaveButton(true)}
          onMouseLeave={e => e.currentTarget.blur()}
          icon={<FaSave />}
          className="floating-footer__button floating-footer__button--save"
        >
          {t("Save")}
        </Button>
      </div>
      <Drawer
        className="modal-pdf-preview"
        width="100%"
        height="calc(100vh - 7px)"
        open={openPreviewModal}
        placement="bottom"
        onClose={handleCancel}
        title={
          <Button type="primary" shape="circle" size="large" onClick={handleCancel}>
            ✕
          </Button>
        }
        footer={null}
      >
        {!previewUrl && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <Spin size="large" />
          </div>
        )}
        <DocumentViewer previewDocumentUrl={previewUrl} loading={!previewUrl} />
      </Drawer>
    </>
  );
}
